import { render, staticRenderFns } from "./PopularCategoryList.vue?vue&type=template&id=51201837&scoped=true&"
import script from "./PopularCategoryList.vue?vue&type=script&lang=js&"
export * from "./PopularCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./PopularCategoryList.vue?vue&type=style&index=0&id=51201837&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51201837",
  null
  
)

export default component.exports